import { 
  SET_LOGIN_REFERRAL
} from '../constants';

export const setLoginReferral = (isInAppBrowser) => dispatch => new Promise( resolve => {
  resolve(dispatch({
    type: SET_LOGIN_REFERRAL,
    payload: isInAppBrowser
  }))
})
